import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function StazaViaFerrataIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="StazaViaFerrataIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
        <circle fill="#FF0000" cx="4.5" cy="84.9" r="4.5"/>
        <circle fill="#FF0000" cx="9.9" cy="72.1" r="4.5"/>
        <circle fill="#FF0000" cx="16.6" cy="60" r="4.5"/>
        <circle fill="#FF0000" cx="70.3" cy="58.7" r="4.5"/>
        <circle fill="#FF0000" cx="57.1" cy="58" r="4.5"/>
        <circle fill="#FF0000" cx="80.6" cy="49.6" r="4.5"/>
        <circle fill="#FF0000" cx="25.1" cy="49" r="4.5"/>
        <circle fill="#FF0000" cx="48.3" cy="47.4" r="4.5"/>
        <circle fill="#FF0000" cx="36.6" cy="41.7" r="4.5"/>
        <circle fill="#FF0000" cx="87.5" cy="37.6" r="4.5"/>
        <circle fill="#FF0000" cx="92.3" cy="24.6" r="4.5"/>
        <circle fill="#FF0000" cx="95.5" cy="11.1" r="4.5"/>
    </svg>
  </SvgIcon>
}

export default StazaViaFerrataIcon;
